import acgMissionBanner from "@/assets/acg-mission-banner.webp";

const ACGMission = () => {
  return (
    <section className="py-16 px-4 bg-[hsl(30,10%,88%)]">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-stretch gap-10">
          {/* Text Content */}
          <div className="md:w-1/2 space-y-5 flex flex-col justify-center">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 border-t-4 border-l-4 border-primary mt-1 flex-shrink-0" />
              <h2 className="text-4xl md:text-5xl font-black text-foreground leading-tight">
                The ACG<br />Mission
              </h2>
            </div>

            <h3 className="text-base font-bold text-foreground">
              Cool-Climate Comfort, Backed by Industry Leading Brands
            </h3>

            <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
              <p>
                ACG Southern Highlands designs, supplies and installs heating and air conditioning built for life at 600 to 750 metres. Frosty mornings, sub-zero starts and mild summers call for systems chosen on winter heating load — not a generic cooling calculation.
              </p>
              <p>
                From our base in Mittagong we look after homes and businesses right across the Highlands — Bowral, Moss Vale, Berrima, Burradoo, Bundanoon, Robertson and beyond — as well as Goulburn and the Wollondilly towns of Picton, Tahmoor, Bargo and Thirlmere.
              </p>
              <p>
                Whether it's a heritage cottage, a rambling country estate or a new family build, we tailor a solution to your home and how you actually live in it. Call 0480 841 485 for a free, no-obligation onsite quote.
              </p>
            </div>


            <a
              href="#about"
              className="inline-block bg-acg-orange text-primary-foreground px-8 py-4 rounded hover:opacity-90 transition-opacity text-sm mt-4 w-fit"
            >
              <span className="block text-xs">Learn more about us</span>
              <span className="uppercase font-black text-base">Discover ACG</span>
            </a>
          </div>

          {/* Image */}
          <div className="md:w-1/2 relative overflow-hidden rounded-lg">
            <img
              src={acgMissionBanner}
              alt="Modern smart home interior with ACG air conditioning system installed — comfort and efficiency"
              className="w-full h-full object-cover object-right"
              width={800}
              height={600}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ACGMission;
